import {Component, Injector} from "@angular/core";
import { ReportTemplateService } from "../../../services/reporttemplate.service";
import { ReportDialogBaseComponent } from "./report-dialog-base/report-dialog-base.component";

@Component({
    selector: 'app-create-report-template',
    templateUrl: './report-dialog-base/report-dialog-base.component.html',
    styleUrls: ['./report-dialog-base/report-dialog-base.component.css'],
    standalone: false
})
export class CreateReportTemplateComponent extends ReportDialogBaseComponent {

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "createReportTemplate";
  }

  public submit() {
    if (!this.validate())
      return;

    this.model.Id = 0;
    this.reportService.create(this.model)
      .subscribe((res) => {
          this.onCreated.emit();
          this.close();
          this.syncService.NotifyEntityChanged("ReportTemplate", this.model.Id);
          super.submit();
        });
  }

 

}
